<div class="home">
    <div class="dashboard-grid">
        <div class="two-column-layout">
            <div class="column left">
                <mat-card class="card-section">
                    <ng-container *ngIf="currentCardStatus === cardStatus.INACTIVE; else activeCard">
                        <div class="inactive-wrapper">
                            <img src="assets/riyadh/riyadh-card.png" class="inactive-card-img" />

                            <h2 class="inactive-title">Card Isn’t Active Yet</h2>

                            <p class="inactive-desc">Tap below to activate your card and start using it instantly for payments.</p>

                            <button mat-button class="activate-btn rounded-pill" (click)="openCardStatusChange(card)">
                                <mat-icon fontIcon="credit_card"></mat-icon>
                                Activate Card
                            </button>
                        </div>
                    </ng-container>
                </mat-card>
            </div>

            <!-- RIGHT SIDE -->
            <div class="column right spending-section">
                <app-spinner [isLoading]="transactionLoading"></app-spinner>

                <!-- TRANSACTIONS LIST -->
                <div class="scroll-card" *ngIf="!transactionLoading && transactions.length > 0">
                    <div class="spending-header">
                        <p>Transactions</p>
                    </div>

                    <div class="scroll-area">
                        <div *ngFor="let tx of transactions" class="transaction-item">
                            <div class="left">
                                <!--[ngClass]="{'payment-received': tx.transaction_type === transactionExtendedType.WALLET_CREDIT}" -->
                                <div class="initials">
                                    {{ getTransactionType(tx.transaction_type) | transactionType }}
                                </div>
                                <div class="meta">
                                    <p class="name">{{ tx.transaction_timestamp | date : 'dd MMM yyyy' }}</p>
                                </div>
                            </div>

                            <div class="amount" [class.negative]="tx.transaction_amount < 0">
                                <p
                                    class="transaction-amount"
                                    [ngClass]="{
                                        'text-red': isSent(tx.transaction_type),
                                        'text-green': !isSent(tx.transaction_type)
                                    }"
                                >
                                    {{ isSent(tx.transaction_type) ? '-' : '+' }}
                                    {{ tx.transaction_amount | currency : tx.transaction_currency : '' }}
                                    {{ tx.transaction_currency }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- EMPTY TRANSACTIONS -->
                <mat-card class="empty-state-card" *ngIf="!transactionLoading && transactions.length === 0">
                    <div class="empty-state-content">
                        <mat-icon fontIcon="credit_card_off" width="60px" height="60px"></mat-icon>
                        <h3 class="empty-title">No Transactions Yet</h3>
                        <p class="empty-desc">Once you start spending, your transactions will show up here.</p>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
</div>

<ng-template #activeCard>
    <ng-container *ngIf="cardType === 'PREPAID'; else creditCard">
        <ng-container *ngTemplateOutlet="prepaidCard"></ng-container>
    </ng-container>
</ng-template>

<ng-template #prepaidCard>
    <mat-card class="card-section" *ngIf="currentCardStatus && currentCardStatus !== cardStatus.INACTIVE">
        <div class="card-wrapper vertical">
            <img src="assets/riyadh/riyadh-card.png" class="debit-card large" />

            <div class="section-spacer"></div>

            <div class="balance-block">
                <p class="label">Available Balance</p>
                <h1 class="balance">SAR {{ selectedWallet.balance | number }}</h1>
            </div>

            <mat-divider></mat-divider>

            <div class="details-section">
                <div class="details-row">
                    <span class="left">Card Type</span>
                    <span class="right">{{ cardType }}</span>
                </div>

                <div class="details-row">
                    <span class="left">Card number</span>
                    <span class="right"> {{ this.card?.last_four | optionalPlaceholder | maskString }}</span>
                </div>
                <div class="details-row">
                    <span class="left"><a (click)="showCardDetails()">Show Card Details</a> </span>
                </div>
            </div>

            <div class="actions d-flex justify-content-end">
                <button mat-button class="btn-primary rounded-pill" *ngIf="currentCardStatus === cardStatus.ACTIVE" (click)="openLoadFundsModal()">
                    <mat-icon fontIcon="add_circle"></mat-icon> Card Top-up
                </button>

                <button
                    mat-button
                    class="btn-secondary rounded-pill card-status"
                    [ngClass]="{
                    status__active: currentCardStatus === 'ACTIVE',
                    status__suspended: currentCardStatus === 'SUSPENDED',
                    status__terminated: currentCardStatus === 'TERMINATED',
                }"
                    (click)="openCardStatusChange(card)"
                >
                    <mat-icon *ngIf="currentCardStatus === cardStatus.SUSPENDED" fontIcon="ac_unit"></mat-icon>
                    <mat-icon *ngIf="currentCardStatus === cardStatus.ACTIVE" style="color: green" fontIcon="check_circle"></mat-icon>
                    <mat-icon *ngIf="currentCardStatus === cardStatus.TERMINATED" style="color: red" fontIcon="block"></mat-icon>
                    {{ card?.status | titlecase }}
                </button>
            </div>
        </div>
    </mat-card>
</ng-template>

<ng-template #creditCard>
    <mat-card class="card-section" *ngIf="currentCardStatus && currentCardStatus !== cardStatus.INACTIVE">
        <div class="card-wrapper vertical">
            <img src="assets/riyadh/riyadh-card.png" class="debit-card large" />

            <div class="section-spacer"></div>

            <div class="balance-block">
                <!-- BALANCE + TOTAL -->
                <p class="label">Available Credit Limit</p>
                <div class="limit-header">
                    <h2 class="limit-amount">SAR {{ selectedWallet.balance | number }}</h2>
                    <span class="total-limit">/ SAR {{ walletForm.controls.total.value | number }}</span>
                </div>

                <!-- SLIM PROGRESS BAR -->
                <mat-progress-bar mode="determinate" [value]="getAvailablePercent()" class="custom-progress"> </mat-progress-bar>

                <!-- LIMIT CONSUMED ROW -->
                <div class="consumed-row">
                    <span class="label">Limit Consumed</span>
                    <span class="consumed-amount">{{ walletForm.controls.total.value - selectedWallet.balance | number }} SAR</span>
                </div>
            </div>

            <mat-divider></mat-divider>

            <div class="details-section">
                <div class="details-row">
                    <span class="left">Card Type</span>
                    <span class="right">{{ cardType }}</span>
                </div>

                <div class="details-row">
                    <span class="left">Card number</span>
                    <span class="right"> {{ this.card?.last_four | optionalPlaceholder | maskString }}</span>
                </div>
                <div class="details-row">
                    <span class="left"><a (click)="showCardDetails()">Show Card Details</a> </span>
                </div>
            </div>

            <div class="actions d-flex justify-content-end">
                <button
                    mat-button
                    class="btn-primary rounded-pill pay-bill-btn"
                    *ngIf="currentCardStatus === cardStatus.ACTIVE"
                    [disabled]="this.walletForm.controls.total.value === selectedWallet.balance"
                    (click)="openPayBillModal()"
                >
                    <mat-icon fontIcon="credit_card"></mat-icon> Pay Credit Bill
                </button>

                <button
                    mat-button
                    class="btn-secondary rounded-pill card-status"
                    [ngClass]="{
                    status__active: currentCardStatus === 'ACTIVE',
                    status__suspended: currentCardStatus === 'SUSPENDED',
                    status__terminated: currentCardStatus === 'TERMINATED',
                }"
                    (click)="openCardStatusChange(card)"
                >
                    <mat-icon *ngIf="currentCardStatus === cardStatus.SUSPENDED" fontIcon="ac_unit"></mat-icon>
                    <mat-icon *ngIf="currentCardStatus === cardStatus.ACTIVE" style="color: green" fontIcon="check_circle"></mat-icon>
                    <mat-icon *ngIf="currentCardStatus === cardStatus.TERMINATED" style="color: red" fontIcon="block"></mat-icon>
                    {{ card?.status | titlecase }}
                </button>
            </div>
        </div>
    </mat-card>
</ng-template>

<div class="iframe-container" *ngIf="iframeUrl">
    <iframe [src]="iframeUrl" width="100%" height="600" frameborder="0" style="border: none"> </iframe>
</div>
